import { DatePipe } from '@angular/common';
import { Pipe, PipeTransform } from '@angular/core';
import { NativeDateAdapter } from '@angular/material/core';
import { environment } from 'src/environments/environment';

export const ASPEN_FORMATS = {
    parse: {
        dateInput: environment.dateFormat,
    },
    display: {
        dateInput: environment.dateFormat,
        monthYearLabel: 'MMM YYYY',
        dateA11yLabel: environment.dateFormat,
        monthYearA11yLabel: 'MMMM YYYY',
    },
};

@Pipe({ name: 'aspenDate' })
export class AspenDatePipe implements PipeTransform {
    private datePipe: DatePipe = new DatePipe('en-GB');
    transform(date: Date) {
        if (date == null || typeof date === 'string') {
            return date;
        }
        if (typeof date === 'number') {
            date = new Date(date);
        }
        try {
            // console.log('Before:', date);
            const tempDate = date;
            // const tempDate = new Date(
            //     date.getTime() - date.getTimezoneOffset() * 60 * 1000
            // );
            // console.log('After', tempDate);
            return this.datePipe.transform(tempDate, environment.dateFormat);
        } catch (e) {
            console.error('Unable to transform date', date, e);
            return date;
        }
    }
}

export class AspenDateAdapter extends NativeDateAdapter {
    environment = environment;
    private datePipe: DatePipe = new DatePipe('en-GB');

    parse(value: any) {
        const values = value.split('/');
        const returnDate = new Date(
            Date.parse(values[2] + '/' + values[1] + '/' + values[0])
        );
        if (isNaN(returnDate.getTime())) {
            return new Date(Date.parse(value));
        } else {
            return returnDate;
        }
    }

    format(date: Date, displayFormat: any): string {
        // console.log('Formatting Date', date, displayFormat);
        if (date == null) {
            return '';
        }
        if (typeof date === 'number') {
            date = new Date(date);
        }
        const tempDate = new Date(date.getTime());
        let result = 'not set';
        // if (displayFormat === 'input') {
        result = this.datePipe.transform(tempDate, environment.dateFormat);
        // } else {
        //     result = date.toUTCString();
        // }

        // console.log('Returning formatted date', result);
        return result;
    }
}
